<div class="layout-container">
    <div #leftSidebar class="left-sidebar obligation-states-navigation" [ngClass]="{'collapsed': (isSidebarCollapsed$ | async)}">
      <ng-content select="[leftSidebar]"></ng-content>
    </div>
    <div class="main-content">
      <ng-content select="[mainContent]"></ng-content>
      <app-footer></app-footer>
    </div>
  </div>
  